import GenericForm from 'components/GenericForm';
import type { GenericFormFields, SitecoreBlockProps } from 'models/sitecore';

interface Props extends SitecoreBlockProps {
	fields?: GenericFormFields;
}

export default function AccountJulaClubSignupForm({ fields }: Props) {
	if (!fields) {
		return null;
	}
	return (
		<GenericForm
			formLocation="AccountJulaClubSignupForm"
			sections={fields.sections}
			errorView={fields.error}
			successView={fields.success}
			loadingView={fields.loading}
		/>
	);
}
AccountJulaClubSignupForm.displayName = 'AccountJulaClubSignupForm_Partial';
